import * as Sentry from '@sentry/react';
import { oppLocalStorage, TStorageNames } from 'helpers/storage';
import { TTenantDataUI } from 'data/types/tenant.types';

const isProd = import.meta.env.REACT_APP_ENVIRONMENT === 'prod';

export const updateSentryUserContext = (
  user?: TTenantDataUI | null,
  isImpersonated?: boolean,
) => {
  if (!isProd) {
    return;
  }

  try {
    // If no user is provided, try to get from localStorage or clear context
    if (!user) {
      const storedUser = oppLocalStorage.getItem(TStorageNames.user);
      if (storedUser) {
        user = storedUser;
      } else {
        Sentry.setUser(null);
        Sentry.setTag('impersonated', undefined);
        return;
      }
    }

    // If impersonation status is not explicitly provided, check localStorage
    if (isImpersonated === undefined) {
      const tenantId = oppLocalStorage.getItem(TStorageNames.tenantId);
      isImpersonated = !!tenantId;
    }

    const { userId, email, name, username, phone } = user || {};

    Sentry.setUser({
      id: userId,
      email,
      name,
      username,
      phone,
    });

    if (isImpersonated) {
      Sentry.setTag('impersonated', 'true');
    } else {
      Sentry.setTag('impersonated', undefined);
    }
  } catch {
    // Silently fail
  }
};

export const clearSentryUserContext = () => {
  if (isProd) {
    try {
      Sentry.setUser(null);
      Sentry.setTag('impersonated', undefined);
    } catch {
      // Silently fail
    }
  }
};
